import { Box, Button, Divider, Grid, IconButton, Modal, Stack, Typography } from "@mui/material";

import { stringConstant } from "../utils/string-utils";
// import '../app/css/additional-styles/home.css'
import { useEffect, useState } from "react";
import { appApi } from "../apiUtils/apiMethod";
import { Url } from "../apiUtils/apiPath";
import { useNavigate } from "react-router-dom";
import Logger from "../utils/logger";
import { CloseOutlined } from "@mui/icons-material";
import MySlider from "./home-conent";

export default function Home() {
    const [versionUpdates, setVersionsUpdate] = useState("")
    const navigate = useNavigate()
    const getVersionsapi = async () => {
        try {
            const result = await appApi(Url.CHECK_UPDATE, "POST", { "Content-Type": "application/json" });
            console.log("Versions_Result >>>>>>>", result);
            if (result.success === true) {
                setVersionsUpdate(result?.data?.application_detail);
            } else {
                console.log("Error Fetching Update");
            }
        } catch (error) {
            console.log("Error Fetching Updates", error);
        }
    };
    useEffect(() => {
        getVersionsapi()
    }, [])

    const handleDownLoad = () => {
        const baseUrl = 'https://dev-api.clinicsoncloud.co/api/';
        const fileUrl = versionUpdates?.['link'];
        const link = document.createElement('a');
        link.href = baseUrl + fileUrl;
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const slides = [
        {
            mediaType: 'image',
            mediaUrl: './images/coc1.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc2.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc3.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc4.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc5.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc6.png'
        },
        {
            mediaType: 'image',
            mediaUrl: './images/coc7.jpg'
        }
    ]
    return (
        <section className="relative">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="pt-32 pb-12 md:pt-40 md:pb-20">

                    {/* Page header */}
                    <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                        <h1 className="h1"> Download Kiosk App</h1>
                        {/* <p className="text-xl text-gray-400 mb-2" data-aos="fade-up" data-aos-delay="200">The COC Health KIOSK app represents a digital platform meticulously crafted to furnish users with a broad spectrum of healthcare services and information. Its functionalities encompass the screening of over 60 health parameters, monitoring of vital signs and health metrics, provision of medical resources and information, as well as facilitating telemedicine consultations. This application is purposefully designed to afford users convenient and efficient access to an array of healthcare services and support.</p> */}
                    </div>
                    <div className="relative border border-white rounded-lg flex flex-row justify-around self-center min-h-10vh items-center mt-1 p-3  w-xl-50%">
                        <div>
                            <h4 className="text-white text-sm">App Name</h4>
                            <h4 className="text-white text-sm">Coc Kiosk App</h4>
                        </div>
                        <div className="border-l border-white h-10"></div>
                        <div>
                            <h4 className="text-white text-sm">Versions</h4>
                            <h4 className="text-white text-sm">{versionUpdates?.apk_version_name}</h4>
                        </div>
                        <div className="border-l border-white h-10"></div>
                        <div className="w-10%">
                            <button className="btn text-white bg-purple-600 hover:bg-purple-700 w-full" onClick={handleDownLoad}>Download</button>
                        </div>
                    </div>

                    <div className=" justify-center items-center my-8">
                        <div className="flex flex-col">
                            <h4 className="h4"> About</h4>
                            <div>Health Connect by Android gives you a simple way to share data between your health, fitness and wellbeing apps We without compromising on privacy. The Health Connect is in beta. We are is excited to share the product.</div>

                        </div>
                        <div className="flex flex-col">
                            <h4 className="h4"> Whats New</h4>
                            <div>Health Connect by Android gives you a simple way to share data between your health, fitness and wellbeing apps We without compromising on privacy. The Health Connect is in beta. We are is excited to share the product.</div>

                        </div>
                    </div>
                    {/* <div className="flex justify-evenly items-center flex-col sm:flex-row">
                        <div className="w-80 aspect-w-16 aspect-h-9 mb-4 sm:mb-0">
                            <video controls className="w-full h-full">
                                <source src="videos/video.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div className="aspect-w-16 aspect-h-9">
                            <img
                                src={'./images/home.png'}
                                alt="home.png"
                                layout="responsive"
                                width={100}
                                height={90}
                                objectFit="cover"
                            />
                        </div>
                    </div> */}
                    <div >
                        <MySlider slides={slides} />
                    </div>
                </div>
            </div>
        </section>
        // <Box
        //     className="landing-theme" alignItems={'center'} position={'relative'} >
        //     <Stack width={'100%'} alignItems={'center'} spacing={1}>
        //         <Typography className="landing-title" fontSize={{ xl: '4rem', lg: '3rem', md: '3rem', sm: '2rem' }} width={{ xl: '50%', lg: '80%', md: '80%', sm: '80%' }}>{stringConstant.DOWNLOAD_TITLE}</Typography>
        //         <Typography className="landing-body" fontSize={{ xl: '2.5rem', lg: '2rem', md: '2rem', sm: '2rem' }} width={{ xl: '50%', lg: '80%', md: '80%', sm: '80%' }}>{stringConstant.DOWNLOAD_BODY}</Typography>
        //     </Stack>
        //     <Stack className="stack-position" width={{ xl: '50%', lg: '60%', md: '60%', sm: '90%' }} >
        //         <Box >
        //             <Typography className="stack-typo">Versions </Typography>
        //             <Typography color={"white"} fontSize={"1.2rem"}>{versionUpdates?.apk_version_code} </Typography>
        //         </Box>
        //         <div style={{ borderRight: '1px solid #ffffff', height: '80%' }}></div>
        //         <Box>
        //             <Typography className="stack-typo">Major</Typography>
        //             <Typography className="stact-typoBody">{versionUpdates?.apk_version_name}</Typography>
        //         </Box>
        //         <div style={{ borderRight: '1px solid #ffffff', height: '80%' }}></div>

        //         <Box width={"20%"}>
        //             <Button className="button-four" onClick={handleDownLoad} >{stringConstant.DOWNLOAD}</Button>
        //         </Box>

        //     </Stack>
        //     <Stack className="gridProps" columnGap={3} justifyContent={'center'} alignItems={'center'} marginBlock={'2%'}>
        //         <Stack className="stackProps" width={{ xl: '50%', lg: '45%', md: '50%' }} height={{ xl: '50vh', lg: '50vh', md: '50vh' }}>
        //             <iframe
        //                 className="iframeContent"
        //                 src="https://www.youtube.com/embed/dS51P9LtQCc?si=8O1oBEhafFmQ01mJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        //                 allowFullScreen
        //                 loading="lazy"
        //             ></iframe>
        //         </Stack>
        //         <Stack className="stackImageProps" width={{ xl: '20%', lg: '25%', md: '30%' }} height={{ xl: '50vh', lg: '50vh', md: '50vh' }}>

        //             <img src="./images/home.png" alt="public/images/home.png" style={{ height: '90%', width: '100%' }} />

        //         </Stack>
        //         <Box className="contentBox" width={{ xl: '30%', lg: '25%', md: '40%' }} height={{ xl: '85%', lg: '85%', md: '90%' }}>
        //             <Box >
        //                 <Typography className="content1" fontSize={{ xl: '2rem', lg: '1.7rem', md: '1.5rem', sm: '1rem' }}>About</Typography>
        //                 <Typography className="content2" fontSize={{ xl: '1.5rem', lg: '1rem', md: '1rem', sm: '1rem' }}>Health Connect by Android gives you a simple way to share data between your health, fitness and wellbeing apps We without compromising on privacy. The Health Connect is in beta. We are is excited to share the product.</Typography>
        //             </Box>
        //             <Box paddingTop={3}>
        //                 <Typography className="content1" fontSize={{ xl: '2rem', lg: '1.7rem', md: '1.5rem', sm: '1rem' }}>Whats New</Typography>
        //                 <Typography className="content2" fontSize={{ xl: '1.5rem', lg: '1rem', md: '1rem', sm: '1rem' }}>Health Connect by Android gives you a simple way to share data between your health, fitness and wellbeing apps We without compromising on privacy. The Health Connect is in beta. We are is excited to share the product.</Typography>
        //             </Box>

        //         </Box>
        //     </Stack>

        // </Box >
    )
}
